import React, { Component } from 'react';
import DocumentTitle from 'react-document-title';
import UA from '../../utils/ua';
import './style.less';

class PaymentAgreement extends Component {
    constructor(props){
        super(props);
        this.state = {
            isMobile: UA.mobileClient
        };
    }

    componentWillMount() {
        let isAllowAgreement = this.props.location.state.isAllowAgreement;
        if(isAllowAgreement) {
            localStorage.setItem('is_allow_agreement', isAllowAgreement)
        }
        localStorage.setItem('no_use_discount', this.props.location.state.notUseDiscount )
        let discountCoupon = this.props.location.state.discountCoupon;
        if(!!discountCoupon && Object.keys(discountCoupon).length > 0) {
            localStorage.setItem('user_discount', JSON.stringify(this.props.location.state.discountCoupon) )
        }
    }

    // 退回上一页
    handleBack = () => {
        window.history.back();
    }

    render(){
        return(
            <DocumentTitle title={'用户支付协议'}>
                <div className={`container customerrules ${ this.state.isMobile ? '' : 'pc' }`}>
                    { !this.state.isMobile &&
                        <div className='header' >
                            <div className="btn back" onClick={ this.handleBack }></div>
                            <h2>用户支付协议</h2>
                            <div className='line'></div>
                        </div>
                    }
                    <div className="content">
                        { this.state.isMobile && <h1>《AirCourse用户支付协议》</h1> }
                        <p>
                        用户您好，在使用AirCourse网络英语课程服务之前，请您应仔细阅读本课程服务协议，在按照本协议提示填写信息、阅读并同意本协议后，即表示您已充分阅读、理解并接受本协议的全部内容。本协议即构成对双方具有约束力的法律文件。甲方届时不应以未阅读本协议的内容或者未获得本站对您问询的解答等理由，主张本协议无效，或要求撤销。AirCourse英语网站上的各项服务的所有权和运作权归杭州潘哒教育科技有限公司所有。本站提供的服务将完全按照其发布的服务条款和操作规则严格执行。
                        </p>
                        <h3>一、协议主体和签订方式</h3>
                        <p>
                        1.本协议中的“甲方”是指购买乙方相应课程的自然人，“乙方”是指“杭州潘哒教育科技有限公司”。本协议中的“学员”或者“甲方学员”是指在乙方的官方网站中的甲方的注册账户下学习甲方所购买的课程包的一名固定学员，即本协议甲方登记的学员本人，未经乙方许可，不得向第三方转让本协议项下的课程服务。
                        </p>
                        <p>
                        2．本协议的“甲方”应为法律上的已满18周岁的完全民事行为能力人，若“甲方”不具备该主体资格，则甲方的监护人应承担因此而导致的一切后果，且乙方有权注销或永久冻结甲方的账户，并向甲方及其监护人索偿相应损失。
                        </p>
                        <p>
                        3.通过甲方账号在乙方网站发生的课程购买行为均视为甲方本人的真实意思，表示甲方本人的行为。本协议通过电子文本形成制成自乙方收到甲方支付的课程费用起生效，一经成立生效即不可撤销。
                        </p>
                        <h3>二、课程服务内容</h3>
                        <p>
                        1.乙方会根据学员的能力阶段，安排最合适的起始课程级别，甲方同意所购买协议课程从该级别开始。
                        </p>
                        <p>
                        2.甲方此次购买课：〖〗元/〖〗课时（天数）课程（以甲方通过乙方支付链接支付最终价格为准）
                        </p>
                        <p>
                        3.乙方提供的课程是按照甲方购买的有效期提供服务，即甲方通过乙方或乙方授权的渠道购买后，即可在所购买的有效期内享受甲方提供的网络在线教学等服务。包括但不限于在线直播课堂，视频音频文件使用等。
                        </p>
                        <p>
                        4.乙方承诺按照甲方支付时所约定的有效天数为甲方提供在线教学服务，超过有效期，甲方账号将会失效，需甲由方重新购买方可继续享受甲方的相关服务内容。在甲方购买的有效期内，乙方每晚将提供一节在线外教直播课，提供的有效服务时长为：〖〗天有效期，即甲方在乙方平台购买后每超过24小时，消耗一天有效期。
                        </p>
                        <h3>三、课程服务</h3>
                        <p>
                        1.甲方通过乙方或乙方授权的渠道购买乙方课程后，即可用购买时的手机号作为登录账号享受有效期内的课程等服务。
                        </p>
                        <p>
                        2.甲方不得使用购买账号用于任何违法，商业用途从而侵犯乙方的合法权益，否则，甲方承担一切乙方损失。
                        </p>
                        <p>
                        3.甲方可以从乙方获取所购买课程相关的支持性辅助服务。乙方应当协助甲方顺利使用平台产品进行学习。
                        </p>
                        <p>
                        4.为保护乙方合法权利，乙方有权限制甲方同一账号绑定的设备数量为【3】台，且甲方同一账号的【3】台设备一经绑定，即不得新增/变更绑定该【3】台设备以外的其他设备。
                        </p>
                        <h3>四、上课规定</h3>
                        <p>
                        1.为确保所在班级良好的课堂氛围，甲方应协助乙方，保障学员在上课过程中不吵闹，不迟到，不早退。
                        </p>
                        <p>
                        2.如遇特殊原因，乙方在告知甲方的同时有权对甲方上课账号做静音、下线等处理。
                        </p>
                        <p>
                        3.甲方或学员在课程进行中如存在以下情形，乙方或外教有权中止课程服务，且扣除课时；同时乙方有权删除该次课程服务的全部视频，且无须承担任何法律后果：
                            <span>(1)衣着暴露，包括但不限于裸露身体隐私部位等；</span>
                            <span>(2)多个孩子上课或非本协议约定的学员本人上课，包括但不限于成人代替上课等；</span>
                            <span>(3)家暴行为或者不适当的管教行为，包括惩罚性的肢体接触或者严重辱骂等；</span>
                            <span>(4)使用危险的用具，包括但不限于刀具、仿真枪等；</span>
                            <span>(5)损害国家的尊严或者利益，泄露国家秘密；</span>
                            <span>(6)危害人身、财产安全，泄露个人隐私；</span>
                            <span>(7)妨碍社会公共秩序或者违背社会良好风尚；</span>
                            <span>(8)有淫秽、色情、赌博、迷信、恐怖、暴力相关的言行；</span>
                            <span>(9)有民族、种族、宗教、性别歧视相关的言行；</span>
                            <span>(10)对外教进行攻击性、歧视性的言行；</span>
                            <span>(11)违反中华人民共和国法律法规的其他行为；</span>
                            <span>(12)违反外教所在地相关法律或乙方平台规则的行为；</span>
                            <span>(13)乙方合理认定应当对甲方中止课程服务或删除相关视频的其他行为。</span>
                        </p>
                        <h3>五、退费</h3>
                        <p>
                        甲方了解并同意签订本合同后，若欲申请解除或终止合同及退费，应在购买后【7】天内向乙方提出解除申请，乙方将在收到申请后的【3】个工作日内原路返还甲方支付的费用。
                        </p>
                        <h3>六、许可使用权</h3>
                        <p>
                        甲方同意，乙方对甲方在乙方网上发表的供学习交流的作品、评价，享有独家的出版、发行和复制的权利。甲方以此授予乙方及其关联公司独家的、全球通用的、永久的、免费的许可使用权利(并有权在多个层面对该权利进行再授权)，使乙方及其关联公司有权(全部或部分地)使用、复制、修订、改写、发布、翻译、分发、执行和展示甲方的使用数据包括但不限于注册资料、交易行为数据及全部展示于网站的各类信息)或制作其派生作品，和/或以现在已知或日后开发的任何形式、媒体或技术，将上述信息纳入其它作品内。
                        </p>
                        <h3>七、知识产权</h3>
                        <p>
                        乙方网站内以任何形式表现的作品(包括但不限于文字、软件、声音、图片、录像、表格、电子邮件等)的著作权，由乙方享有，甲方未经许可，不得擅自对乙方的包括教材、电子课件在内的任何作品进行任何形式的翻录、复制或从事其他任何违反著作权法等相关法律、法规的活动。对侵犯乙方知识产权的个人和组织，乙方及其关联公司将依法追究其民事或刑事责任。
                        </p>
                        <h3>八、不可抗力</h3>
                        <p>
                        提供课程服务的外教所在地发生突发的自然灾害、政治动乱等不以乙方的意志为转移的突发事件，乙方对甲方有通知义务，并且有权延期提供服务，或者暂时停止服务。
                        </p>
                        <h3>九、责任限制</h3>
                        <p>
                        如因不可抗力或其他乙方无法控制的原因使乙方系统崩溃或无法正常使用导致网上交易无法完成或丢失有关的信息、记录等，乙方不承担责任，但是乙方会尽可能合理地协助处理相关事宜，并努力使甲方免受经济损失。
                        </p>
                        <h3>十、法律管辖和适用</h3>
                        <p>
                        1.本协议的订立、执行和解释及争议的解决均应适用中国法律。如发生服务条款与中国法律相抵触时，则这些条款将完全按法律规定重新解释，而其它合法条款则依旧保持对用户产生法律效力和影响。
                        </p>
                        <p>
                        2.本协议的规定是可分割的，如本协议任何规定被裁定为无效或不可执行，该规定可被删除而其余条款应予以执行。
                        </p>
                        <p>
                        3.如双方就本协议内容或其执行发生任何争议，双方应尽力友好协商解决；协商不成时，任何一方均可向乙方所在地的人民法院提起诉讼。
                        </p>
                        <h3 className="textIndent">s</h3>
                        <p>
                        甲方（学员家长）
                        </p>
                        <p>
                        乙方（公司）：
                        </p>
                        <p>
                        公司名称：杭州潘哒教育科技有限公司
                        </p>
                        <p>
                        杭州市拱墅区丰潭路508号天行国际中心7号楼11层1101室
                        </p>
                        <p>
                        联系电话：0571-89809613
                        </p>
                    </div>
                </div>
            </DocumentTitle>
        )
    }
}

export default PaymentAgreement;



// WEBPACK FOOTER //
// ./src/components/paymentAgreement/paymentAgreement.jsx